import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './product-gallery.css'

const ProductGallery = (props) => {
  return (
    <div className="product-gallery-container1">
      <Helmet>
        <title>Product-Gallery - Nature Ready Exports</title>
        <meta
          property="og:title"
          content="Product-Gallery - Nature Ready Exports"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="product-gallery-container2">
        <div className="product-gallery-container3">
          <Script
            html={`<style>
        @keyframes fadeInSlideUp {from {opacity: 0;
transform: translateY(30px);}
to {opacity: 1;
transform: translateY(0);}}@keyframes pulse {0%,100% {transform: scale(1);}
50% {transform: scale(1.05);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="product-gallery-container4">
        <div className="product-gallery-container5">
          <Script
            html={`<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: var(--font-family-body);
  line-height: 1.6;
  color: var(--color-on-surface);
  background-color: var(--color-surface);
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="product-gallery-container6">
        <div className="product-gallery-container7">
          <Script
            html={`<script defer data-name="product-gallery-interactions">
(function(){
  // Product card hover effects and inquiry functionality
  const productCards = document.querySelectorAll(".product-card")
  const inquiryOverlay = document.getElementById("inquiryOverlay")
  const inquiryForm = document.getElementById("inquiryForm")
  const closeModal = document.getElementById("closeModal")
  const cancelButton = document.getElementById("cancelButton")
  const floatingInquiryBtn = document.getElementById("floatingInquiryBtn")
  const inquiryButtons = document.querySelectorAll(
    ".overlay-cta, .inquiry-cta, .floating-btn"
  )

  // Filter functionality
  const filterButtons = document.querySelectorAll(".filter-btn")
  const filterCheckboxes = document.querySelectorAll(".filter-checkbox")
  const sortSelect = document.querySelector(".sort-select")
  const searchInput = document.querySelector(".search-input")

  // Enhanced product card interactions
  productCards.forEach((card, index) => {
    card.addEventListener("mouseenter", function () {
      this.style.transform = "translateY(-8px) rotateX(5deg)"
      this.style.transition = "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
    })

    card.addEventListener("mouseleave", function () {
      this.style.transform = "translateY(0) rotateX(0deg)"
    })
  })

  // Inquiry overlay functionality
  function openInquiryOverlay() {
    inquiryOverlay.classList.add("active")
    document.body.style.overflow = "hidden"
  }

  function closeInquiryOverlay() {
    inquiryOverlay.classList.remove("active")
    document.body.style.overflow = ""
    inquiryForm.reset()
  }

  inquiryButtons.forEach((btn) => {
    btn.addEventListener("click", openInquiryOverlay)
  })

  closeModal.addEventListener("click", closeInquiryOverlay)
  cancelButton.addEventListener("click", closeInquiryOverlay)

  inquiryOverlay.addEventListener("click", function (e) {
    if (e.target === inquiryOverlay) {
      closeInquiryOverlay()
    }
  })

  // Form submission
  inquiryForm.addEventListener("submit", function (e) {
    e.preventDefault()

    // Simulate form submission
    const formData = new FormData(this)

    // Show success message
    const successMessage = document.createElement("div")
    successMessage.className = "form-success"
    successMessage.innerHTML = \`
    <h4>Inquiry Sent Successfully!</h4>
    <p>Thank you. Your request has been received. A Nature Ready export specialist will respond within 48 hours with tailored pricing and next steps.</p>
    <button class="btn btn-primary" onclick="closeInquiryOverlay()">Close</button>
  \`

    const modalContent = document.querySelector(".modal-content")
    modalContent.innerHTML = ""
    modalContent.appendChild(successMessage)

    setTimeout(() => {
      closeInquiryOverlay()
    }, 3000)
  })

  // Filter functionality
  filterButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      filterButtons.forEach((b) => b.classList.remove("active"))
      this.classList.add("active")

      // Simulate filtering animation
      productCards.forEach((card, index) => {
        card.style.animation = "none"
        setTimeout(() => {
          card.style.animation = \`fadeInSlideUp 400ms ease-out both \${
            index * 50
          }ms\`
        }, 10)
      })
    })
  })

  // Search functionality
  searchInput.addEventListener("input", function () {
    const searchTerm = this.value.toLowerCase()

    productCards.forEach((card) => {
      const productName = card
        .querySelector(".product-name")
        .textContent.toLowerCase()
      const isVisible = productName.includes(searchTerm)

      card.style.display = isVisible ? "block" : "none"

      if (isVisible) {
        card.style.animation = "fadeInSlideUp 300ms ease-out both"
      }
    })
  })

  // Sort functionality
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      const sortBy = this.value
      const productGrid = document.querySelector(".product-grid")
      const cards = Array.from(productCards)

      // Simple sort simulation
      cards.forEach((card, index) => {
        card.style.animation = "none"
        setTimeout(() => {
          card.style.animation = \`fadeInSlideUp 300ms ease-out both \${
            index * 30
          }ms\`
        }, 100)
      })
    })
  }

  // Checkbox interactions
  filterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const label = this.closest(".checkbox-label")

      if (this.checked) {
        label.style.transform = "scale(1.02)"
        setTimeout(() => {
          label.style.transform = "scale(1)"
        }, 150)
      }
    })
  })

  // Badge hover effects
  const badges = document.querySelectorAll(".badge")
  badges.forEach((badge) => {
    badge.addEventListener("mouseenter", function () {
      this.style.transform = "scale(1.05)"
      this.style.transition = "transform 0.2s ease"
    })

    badge.addEventListener("mouseleave", function () {
      this.style.transform = "scale(1)"
    })
  })

  // Floating button scroll behavior
  let lastScrollTop = 0
  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const floatingBtn = document.querySelector(".floating-inquiry-btn")

    if (scrollTop > lastScrollTop && scrollTop > 300) {
      floatingBtn.style.transform = "translateY(100px)"
    } else {
      floatingBtn.style.transform = "translateY(0)"
    }

    lastScrollTop = scrollTop
  })

  // Intersection Observer for animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.animationDelay = "0ms"
        entry.target.style.animationPlayState = "running"
      }
    })
  }, observerOptions)

  // Observe all animated elements
  document.querySelectorAll('[style*="animation"]').forEach((el) => {
    observer.observe(el)
  })

  // Trust card hover effects
  const trustCards = document.querySelectorAll(".trust-card")
  trustCards.forEach((card) => {
    card.addEventListener("mouseenter", function () {
      this.querySelector(".trust-icon").style.transform =
        "scale(1.1) rotate(5deg)"
    })

    card.addEventListener("mouseleave", function () {
      this.querySelector(".trust-icon").style.transform =
        "scale(1) rotate(0deg)"
    })
  })

  // Transparency card stagger animation
  const transparencyCards = document.querySelectorAll(".transparency-card")
  const transparencyObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          transparencyCards.forEach((card, index) => {
            setTimeout(() => {
              card.style.transform = "translateY(0)"
              card.style.opacity = "1"
            }, index * 100)
          })
        }
      })
    },
    { threshold: 0.2 }
  )

  if (transparencyCards.length > 0) {
    transparencyObserver.observe(transparencyCards[0])
  }

  // Intersection Observer for trust & transparency cards visibility animation
  const trustTransparencyObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible")
          trustTransparencyObserver.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.2 }
  )
  const trustCards = document.querySelectorAll('.trust-card');
  const transparencyCards = document.querySelectorAll('.transparency-card');

  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };

  const cardObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, index * 100); // 100ms delay between each card
        cardObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  trustCards.forEach(card => cardObserver.observe(card));
  transparencyCards.forEach(card => cardObserver.observe(card));

  // Observe all trust and transparency cards
  document.querySelectorAll(".trust-card, .transparency-card").forEach((card) => {
    trustTransparencyObserver.observe(card)
  })


  // Keyboard accessibility
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && inquiryOverlay.classList.contains("active")) {
      closeInquiryOverlay()
    }
  })

  // Form validation enhancements
  const formInputs = document.querySelectorAll(".form-input, .form-textarea")
  formInputs.forEach((input) => {
    input.addEventListener("blur", function () {
      if (this.checkValidity()) {
        this.style.borderColor = "var(--color-accent)"
      } else {
        this.style.borderColor = "#e74c3c"
      }
    })

    input.addEventListener("focus", function () {
      this.style.borderColor = "var(--color-primary)"
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <main>
        <section id="hero" className="hero-section1">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            src="https://videos.pexels.com/video-files/7116718/7116718-hd_1080_1920_25fps.mp4"
            className="hero-video"
          ></video>
          <div className="hero-overlay1"></div>
          <div className="hero-content1">
            <div className="hero-text-container">
              <div className="hero-leaf-accent">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10"></path>
                    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
                  </g>
                </svg>
              </div>
              <h1 className="hero-title">
                {' '}
                Nature Ready — Exports Curated from India&apos;s Finest Origins
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </h1>
              <p className="hero-subtitle">
                {' '}
                Hand-selected, sustainably sourced products crafted for global
                markets. Explore premium ingredients and finished goods with
                full traceability, quality certifications, and export-ready
                packaging.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="hero-stats">
              <div className="hero-stat-item">
                <span className="hero-stat-number">Premium</span>
                <span className="hero-stat-label">Export Products</span>
              </div>
              <div className="hero-stat-item">
                <span className="hero-stat-number">Global</span>
                <span className="hero-stat-label">Distribution Network</span>
              </div>
              <div className="hero-stat-item">
                <span className="hero-stat-number">FSSAI</span>
                <span className="hero-stat-label">Certified Quality</span>
              </div>
            </div>
          </div>
        </section>
        <section id="product-gallery" className="product-gallery-section">
          <div className="gallery-header">
            <h2 className="section-title">
              Exquisite Collection — Handpicked for Export
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </h2>
            <p className="section-subtitle">
              Explore our curated selection of premium, sustainably sourced
              products. Each card reveals essential specs, origin, and
              certification badges for confident sourcing.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>

          <div className="product-grid">
            {/* Product 1 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/MalyarC_Prod.png')}
                  alt="Malyar Grade C Raisins"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Malyar Grade C Raisins — Premium Quality
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 15 kg</span>
                  <span>Pack: 100 units</span>
                  <span>MOQ: 1 Case</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-natural">Natural</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 2–3 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 2 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/MalyarAA_Prod.png')}
                  alt="Malyar AA Raisins"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Malyar AA Raisins — Superior Grade
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 20 kg</span>
                  <span>Pack: 150 units</span>
                  <span>MOQ: 1 Pallet</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-premium">Premium</span>
                  <span className="badge badge-sustainable">Sustainable</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 2–4 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 3 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/Golden_Round_Prod.png')}
                  alt="Golden Round Raisins"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Golden Round Raisins — Premium Select
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 12 kg</span>
                  <span>Pack: 80 units</span>
                  <span>MOQ: 2 Cases</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-golden">Golden</span>
                  <span className="badge badge-natural">Natural</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 1–3 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 4 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/YellowRound_Prod.png')}
                  alt="Yellow Round Raisins"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Yellow Round Raisins — Choice Grade
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 18 kg</span>
                  <span>Pack: 120 units</span>
                  <span>MOQ: 1 Case</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-organic">Natural</span>
                  <span className="badge badge-traceable">Traceable</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 2–3 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 5 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/BlackRaisins_Prod.jpg')}
                  alt="Black Raisins"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Black Raisins — Premium Seedless
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 25 kg</span>
                  <span>Pack: 200 units</span>
                  <span>MOQ: 1 Pallet</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-organic">Natural</span>
                  <span className="badge badge-seedless">Seedless</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 2–4 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 6 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/Moringa_Prod.png')}
                  alt="Moringa Leaf Powder"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Moringa Leaf Powder — Export Grade
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 20 kg</span>
                  <span>Pack: 100 units</span>
                  <span>MOQ: 1 Pallet</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-organic">Organic</span>
                  <span className="badge badge-superfood">Superfood</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 1–3 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 7 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/Turmeric_Powder_Prod.jpg')}
                  alt="Turmeric Powder"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Turmeric Powder — Curcumin 3–5%
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 25 kg</span>
                  <span>Pack: 150 units</span>
                  <span>MOQ: 1 Case</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-organic">Organic</span>
                  <span className="badge badge-pure">Pure</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 2–3 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 8 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/TurmericFinger_Prod.png')}
                  alt="Turmeric Fingers"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Turmeric Fingers — Whole • Grade A
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 30 kg</span>
                  <span>Pack: 100 units</span>
                  <span>MOQ: 1 Pallet</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-organic">Organic</span>
                  <span className="badge badge-premium">Premium</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 3–4 weeks</span>
                </div>
              </div>
            </div>

            {/* Product 9 */}
            <div className="product-card1">
              <div className="product-image-container">
                <img
                  src={require('../images/Turmeric_Extract_Prod.jpg')}
                  alt="Turmeric Extract"
                  loading="lazy"
                  className="product-image1"
                />
                <div className="product-overlay1">
                  <button className="overlay-cta btn btn-primary">
                    Request Inquiry
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">
                  Turmeric Extract — Curcumin 95%
                </h3>
                <div className="product-specs">
                  <span>Net Weight: 10 kg</span>
                  <span>Pack: 50 units</span>
                  <span>MOQ: 2 Cases</span>
                </div>
                <div className="sustainability-badges">
                  <span className="badge badge-premium">Premium</span>
                  <span className="badge badge-high-potency">High Potency</span>
                </div>
                <div className="product-price">
                  <span>Contact for Export Pricing</span>
                </div>
                <div className="product-availability">
                  <span>Available • Lead Time: 2–4 weeks</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="trust" className="trust-section1">
          <div className="trust-grid1">
            <div className="trust-card">
              <div className="trust-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  ></path>
                </svg>
              </div>
              <h3 className="trust-title">Trusted Global Standards</h3>
              <p className="trust-description">
                {' '}
                Certified for export excellence — our farms and facilities operate under recognized quality standards, holding exporter licenses and FSSAI-based certifications. 
                Each product is responsibly sourced and quality controlled, with certificate links available for transparency.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="trust-card">
              <div className="trust-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                  </g>
                </svg>
              </div>
              <h3 className="trust-title">Our Worldwide Reach</h3>
              <p className="trust-description">
                {' '}
                From India&apos;s highlands to premium tables across Europe,
                North America and Asia — Nature Ready partners with vetted
                logistics providers to ensure secure, trackable shipment and
                consistent quality at destination.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="trust-card testimonial-card1">
              <div className="testimonial-quotes">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                  ></path>
                </svg>
              </div>
              <h3 className="trust-title">Select Customer Voices</h3>
              <blockquote className="testimonial-text">
                {' '}
                &quot;Exceptional quality and consistent delivery. The
                sustainability practices are evident in every shipment.&quot;
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </blockquote>
              <cite className="testimonial-author">
                {' '}
                — L. Mehta, Specialty Foods Importer
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </cite>
            </div>
            <div className="trust-card">
              <div className="trust-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                    <circle cx="17" cy="18" r="2"></circle>
                    <circle cx="7" cy="18" r="2"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="trust-title">Why Buyers Rely on Us</h3>
              <p className="trust-description">
                {' '}
                Transparent provenance, traceable certificates, and responsive
                export support — streamlined for B2B buyers and boutique
                retailers seeking luxury, sustainable goods.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
          </div>
        </section>
        <section id="transparency" className="transparency-section">
          <div className="transparency-header">
            <h2 className="section-title">Material Transparency</h2>
            <p className="section-subtitle">
              {' '}
              Complete visibility into our sourcing, processing, and
              sustainability practices
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>
          <div className="transparency-grid">
            <div className="transparency-card">
              <div className="card-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696a10.75 10.75 0 0 1 19.876 0a1 1 0 0 1 0 .696a10.75 10.75 0 0 1-19.876 0"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="card-title">Sourcing &amp; Origin</h3>
              <p className="card-content">
                {' '}
                Every ingredient is traced to its place of origin. We partner
                with vetted growers and cooperatives across India — listed by
                region on our traceability map — so you can see where each
                harvest began.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="transparency-card">
              <div className="card-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10"></path>
                    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
                  </g>
                </svg>
              </div>
              <h3 className="card-title">Sustainable Practices</h3>
              <p className="card-content">
                {' '}
                Regenerative farming, water-conserving harvests, and low-impact
                processing are standard across our supply chain. Materials meet
                rigorous sustainability checkpoints and carbon-reduction
                measures.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="transparency-card">
              <div className="card-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path d="M12 15a3 3 0 1 0 6 0a3 3 0 1 0-6 0"></path>
                    <path d="M13 17.5V22l2-1.5l2 1.5v-4.5"></path>
                    <path d="M10 19H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-1 1.73M6 9h12M6 12h3m-3 3h2"></path>
                  </g>
                </svg>
              </div>
              <h3 className="card-title">Certifications &amp; Standards</h3>
              <p className="card-content">
                {' '}
                Products are verified against international export standards and
                hold recognized certifications for organic, fair-trade, and
                responsible sourcing with full audit reports.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="transparency-card">
              <div className="card-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  >
                    <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73zm1 .27V12"></path>
                    <path d="M3.29 7L12 12l8.71-5M7.5 4.27l9 5.15"></path>
                  </g>
                </svg>
              </div>
              <h3 className="card-title">Packaging &amp; Transport</h3>
              <p className="card-content">
                {' '}
                Packaging uses recycled and recyclable materials with protective
                inserts designed for long-haul export. Shipping processes
                prioritize product integrity while minimizing emissions.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="transparency-card">
              <div className="card-icon1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  ></path>
                </svg>
              </div>
              <h3 className="card-title">Batch-Level Accountability</h3>
              <p className="card-content">
                {' '}
                Every shipment includes batch numbers and a downloadable
                provenance certificate. Request testing or custom documentation
                via the inquiry flow for complete transparency.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer></Footer>
      
    </div>
  )
}

export default ProductGallery
